import { takeLatest } from 'redux-saga/effects';
import { delayInputOfferPrice } from './delayInputOfferPrice';
import { INPUT_OFFER_PRICE } from '../../reducers';

export function* offerSagas() {
  yield takeLatest([INPUT_OFFER_PRICE], delayInputOfferPrice);
}
